import I18N from '@leverege/i18n';
import { getObjectType } from "../util/OpenApiTypeUtil.js";
import OpenApiAttribute from './OpenApiAttribute.js';
export default class OpenApiBlueprint {
  constructor(model, cxt) {
    this.cxt = cxt;
    this.apiName = cxt.apiName;
    this.model = model;
    this.tags = model['x-lev-tags'] ?? [];
    this.type = getObjectType(this.apiName, model['x-lev-object-type']);
    this.idKey = `${this.model['x-lev-object-type']}Id`;
    this.i18n = I18N.ns(`openApi.blueprint.${this.type}`);
    this.attributes = model.properties && Object.entries(model.properties).map(([path, attr]) => {
      return new OpenApiAttribute(this, {
        path,
        ...attr
      });
    });
    this.nameAttr = this.attributes.find(attr => attr.isName)?.path ?? this.attributes.find(attr => attr?.path === 'id')?.path;
  }
  toAttributePlugin(attr) {
    return attr.toPlugin();
  }
  installAttributes(molten) {
    this.attributes?.forEach(attr => {
      attr.install(molten);
    });
  }
  get name() {
    return this.getName();
  }
  getName(count = 1) {
    if (count === 1) {
      return this.i18n.t('name', this.model.title, {
        count
      });
    }
    return this.i18n.t('name', `${this.model.title}s`, {
      count
    });
  }
  getIcon(iconName) {
    return this.i18n.tIcon(iconName);
  }
  getString = (strName, defaultValue) => {
    return this.i18n.t(strName, defaultValue);
  };

  /**
   * Returns true if the tags include the specified tab
   */
  hasTag(tag) {
    return this.tags.includes(tag);
  }

  /**
     * Returns the first tag starting with the prefix
     * If strip is true, this will return the value of the 
     * tag after the prefix
     */
  getTagStartingWith(prefix, strip) {
    const arr = this.tags;
    if (arr == null) {
      return null;
    }
    const val = arr.find(t => t.startsWith(prefix));
    if (val && strip) {
      return val.substring(prefix.length);
    }
    return val;
  }

  /**
     * Returns all tags starting with the prefix
     * If strip is true, this will return the value of the 
     * tag after the prefix
     */
  getTagsStartingWith(prefix, strip) {
    let arr = this.tags;
    if (arr == null) {
      return [];
    }
    arr = arr.filter(t => t.startsWith(prefix));
    if (arr.length > 0 && strip) {
      return arr.map(val => val.substring(prefix.length));
    }
    return arr;
  }
}